// extracted by mini-css-extract-plugin
export default {"action":"styles_action__Q1OAQ","label":"styles_label__-pkXo"};